import React, {useEffect, useState} from 'react';
import {Grid2, Stack} from "@mui/material";
import {BirdhouseElement} from "./birdhouse-element/BirdhouseElement";
import {get_birdhouses} from "../api/routes";
import {useLoading} from "../loading-context/useLoading";

export const MainView = () => {
    const [birdhouseList, setBirdHouseList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (birdhouseList.length) return;

        fetch(get_birdhouses)
            .then(response => response.json())
            .then(data => setBirdHouseList(data))
            .catch()
            .finally(() => setIsLoading(false));
    }, []);

    useLoading(isLoading);

    if (isLoading) return null;

    return (
        <Stack justifyContent="center" sx={{ px: "10px", pt: "20px", mb: 2 }}>
            <Grid2 container spacing={2} justifyContent="center">
                {birdhouseList.map((data, index) => (
                    <BirdhouseElement img={data.img_url} key={index} data={data} />
                ))}
            </Grid2>
        </Stack>
    );
};
